// Dependencies imports
import React, { useEffect, useState } from "react";
import { Tab } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { awsSignIn, authData } from "../../redux/auth/authSlice";

// Local imports
import UserHeader from "../Header/UserHeader/UserHeader";
import AttendanceGrid from "./AttendanceGrid";
import MiniGrid from "./MiniGrid";
// import AssignmentGrid from './AssignmentGrid';
// import AssesmentGrid from './AssesmentGrid';
import config from "../../config/aws-exports";
import { Constants } from "../../config/constants";
import { API } from "aws-amplify";

// Style imports
import Rep from "./Reports.module.scss";
import BatchAnalytics from "../Reports&Analytics/BatchAnalytics/BatchAnalytics";
import ProgramAnalytics from "../Reports&Analytics/ProgramAnalytics/ProgramAnalytics";
import InstructorAnalytics from "../Reports&Analytics/InstructorAnalytics/InstructorAnalytics";

// Start of Reports component
const Reports = () => {
  const dispatch = useDispatch();
  let userDetails = useSelector(authData);
  const [progDetails, setProgDetails] = useState();
  const [attendLoad, setAttendLoad] = useState(false);
  const [sessionCount, setSessionCount] = useState();
  const [attendanceList, setAttendancelist] = useState([]);
  const [ttitle, setTtitle] = useState([]);
  const [per, setPer] = useState(0);
  const [loading, setLoading] = useState(false);
  const [batchAnalytics, setBatchAnalytics] = useState([]);
  const [progress, setProgress] = useState(0);
  const [userscount, setUserscount] = useState(0);
  const [userData, setUserData] = useState([]);
  const [newBcid, setBcid] = useState();

  useEffect(() => {
    breadcrumb();
    getProgDetails();
    getUsersData();
  }, []);

  function breadcrumb() {
    let sdata = { ...userDetails };
    let temp = [...sdata.breadcrumb];

    temp[2] = {
      name: "Reports",
      path: "/Reports",
    };

    sdata.breadcrumb = temp;

    dispatch(awsSignIn(sdata));
  }

  async function getAttendanceData(bcid) {
    setAttendLoad(true);
    const bodyParam = {
      body: {
        action: "get",
        bpid: userDetails.curprgcou.bpid,
        oid: config.aws_org_id,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      console.log(bodyParam.body);
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        `/attendance`,
        bodyParam
      );
      console.log("response", response);
      setAttendancelist(response);
      convertData(response, bcid);
      console.log("convertdata", bcid);
      setAttendLoad(false);
    } catch (error) {
      console.error(error);
    }
  }

  function convertData(data, bcid) {
    console.log("rowdata" + JSON.stringify(data));
    let temp = [];

    for (let i = 0; i < data.length; i++) {
      let obj = {};
      obj.id = i;
      if (
        data[i].USN !== undefined &&
        data[i].USN[userDetails.curprgcou.bpid] !== undefined
      ) {
        obj.Enrollment = data[i].USN[userDetails.curprgcou.bpid].usn;
      }
      obj.Name = data[i].UNAME;
      if (
        data[i].ATEND !== undefined &&
        data[i].ATEND[userDetails.curprgcou.bpid] !== undefined &&
        data[i].ATEND[userDetails.curprgcou.bpid][bcid] !== undefined
      ) {
        obj.Total = data[i].ATEND[userDetails.curprgcou.bpid][bcid].count;
      } else {
        obj.Total = "";
      }
      if (data[i].UR != undefined && data[i].UR == "User") {
        temp.push(obj);
      }
    }
    console.log("temp", temp);
    setUserData(temp);
  }

  async function getSessionCount(value) {
    setLoading(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: userDetails.curprgcou.bpid,
        bcid: value,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      console.log(bodyParam.body);
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_INSTRUCTOR_SESSION_COUNT,
        bodyParam
      );
      if (response === undefined || response === null) {
        setSessionCount(undefined);
      } else {
        setSessionCount(response);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  async function getUsersData() {
    setLoading(true);
    const bodyParam = {
      body: {
        action: "get",
        bpid: userDetails.curprgcou.bpid,
        oid: config.aws_org_id,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      console.log(bodyParam.body);
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        `/attendance`,
        bodyParam
      );
      setUserscount(response.length);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  async function getProgDetails() {
    const bodyParam = {
      body: {
        bpid: userDetails.curprgcou.bpid,
        oid: config.aws_org_id,
        pid: userDetails.curprgcou.pid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    if (
      userDetails.role == "Instructors" ||
      userDetails.role == "Coordinators"
    ) {
      bodyParam.body.eid = userDetails.eid;
    }
    try {
      console.log("getProgramsDetails===", bodyParam.body);
      const PDetails = await API.post(
        config.aws_cloud_logic_custom_name,
        `/getProgramsDetails`,
        bodyParam
      );
      console.log("PDetails==", PDetails);
      setProgDetails(PDetails);
      //setLoading(false);
      console.log(PDetails);
    } catch (error) {
      console.error(error);
    }
  }

  console.log("sessisoncount", sessionCount);

  // Data for tabs
  const panes = [
    {
      menuItem: "Attendance",
      render: () => (
        <Tab.Pane>
          <div className={Rep.gridcontainer}>
            <AttendanceGrid
              userData={userData}
              attendanceList={attendanceList}
              setAttendancelist={setAttendancelist}
              getAttendanceData={getAttendanceData}
              setAttendLoad={setAttendLoad}
              attendLoad={attendLoad}
              newBcid={newBcid}
            />
          </div>
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Student analytics",
      render: () => (
        <Tab.Pane active={true}>
          <BatchAnalytics
            progDetails={progDetails}
            setProgDetails={setProgDetails}
            batchAnalytics={batchAnalytics}
            progress={progress}
            per={per}
            loading={loading}
            userscount={userscount}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Instructor analytics",
      render: () => (
        <Tab.Pane active={true}>
          <InstructorAnalytics sessionCount={sessionCount} />
        </Tab.Pane>
      ),
    },
  ];

  async function getBatchAnalytics(value, courses) {
    var vall;
    courses.some(function (entry, i) {
      if (entry.btid == value) {
        vall = entry;
        return entry;
      }
    });
    console.log("vallvall", vall);
    setLoading(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: userDetails.curprgcou.bpid,
        bcid: value,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/getUserBatchReport",
        bodyParam
        //`${Constants.GET_MY_PROGRAMS}`, bodyParam,
      );

      //setCourseId(courseId);
      // setCourseId((curr) =>
      // produce(curr, (v) => {
      //   v.cid = progDetails.pcurriculum[param.target.value].tid;
      //   v.bcid = progDetails.pcurriculum[param.target.value].btid;
      // })
      //);

      let sdata = { ...userDetails };
      sdata.cid = vall.tid;
      sdata.bcid = value;
      sdata.ctitle = vall.ttitle;
      dispatch(awsSignIn(sdata));
      setBatchAnalytics(response.rows);
      setProgress(response.ucount);
      let tper =
        response.rows.length > 0
          ? (response.ucount / response.rows.length) * 100
          : 0;
      setPer(tper);
      setLoading(false);
    } catch (error) {}
  }

  console.log("batchanalytics", batchAnalytics);

  function groupByKey(array, key) {
    return array.reduce((hash, obj) => {
      if (obj[key] === undefined) return hash;
      return Object.assign(hash, {
        [obj[key]]: (hash[obj[key]] || []).concat(obj),
      });
    }, {});
  }

  var result =
    progDetails == undefined || progDetails == null
      ? {}
      : groupByKey(progDetails.pcurriculum, "semester");

  console.log("Resule", result);
  console.log("onclik ttitle", ttitle);
  return (
    <div className={Rep.maincontainer}>
      <UserHeader Bindex={2} />
      <h3 className={Rep.heading}>Reports</h3>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyItems: "flex-start",
          padding: "10px 0px",
          gap: "20px",
        }}
      >
        <h3 style={{ width: "130px" }}>Select Semester</h3>
        <select
          className="classInput_assign_assess"
          style={{
            marginBottom: "0",
            width: "250px",
            minWidth: "200px",
            gap: "30px",
            borderRadius: "5px",
          }}
          onChange={(event) => {
            setTtitle(result[event.target.value]);
            console.log("result", result[event.target.value]);
          }}
        >
          <option value="0" selected="selected" disabled>
            Select Semester
          </option>
          {Object.keys(result).length === 0 ? (
            <option disabled>No Data</option>
          ) : (
            Object.keys(result).map((value, key) => {
              return (
                <option value={value} key={"curr" + key}>
                  {"Semester"} {value}
                </option>
              );
            })
          )}
          ;
        </select>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyItems: "flex-start",
          padding: "10px 0px",
          gap: "20px",
        }}
      >
        <h3 style={{ width: "130px" }}>Select Course</h3>
        <select
          className="classInput_assign_assess"
          style={{
            marginBottom: "0",
            width: "250px",
            minWidth: "200px",
            borderRadius: "5px",
          }}
          onChange={(event) => {
            console.log("eventbtid", event.target.value);
            getBatchAnalytics(event.target.value, ttitle);
            setBcid(event.target.value);
            getSessionCount(event.target.value);
            getAttendanceData(event.target.value);
          }}
        >
          <option value="0" selected="selected" disabled>
            Select Course
          </option>
          {ttitle.length === 0 ? (
            <option disabled>Select Semester</option>
          ) : (
            ttitle.map((value, index) => {
              return (
                <option value={value.btid} key={"curr" + index}>
                  {value.ttitle}
                </option>
              );
            })
          )}
          ;
        </select>
      </div>
      <div className={Rep.gridholder}>
        <Tab panes={panes} />
      </div>
    </div>
  );
};

export default Reports;
